module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vm-progress",
    class: [
      'vm-progress--' + _vm.type,
      _vm.status ? 'is-' + _vm.status : '',
      {
        'vm-progress--without-text': !_vm.showText,
        'vm-progress--text-inside': _vm.textInside
      }
    ]
  }, [(_vm.type === 'line') ? _c('div', {
    staticClass: "vm-progress-bar"
  }, [_c('div', {
    staticClass: "vm-progress-bar__outer",
    style: ({
      height: _vm.strokeWidth + 'px',
      backgroundColor: _vm.trackColor
    })
  }, [_c('div', {
    staticClass: "vm-progress-bar__inner",
    class: [{
      'vm-progress-bar__striped': _vm.striped
    }, _vm.linearClassName],
    style: (_vm.barStyle)
  }, [(_vm.showText && _vm.textInside) ? _c('div', {
    staticClass: "vm-progress-bar__innerText"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.percentage) + "%")])], 2) : _vm._e()])])]) : _c('div', {
    staticClass: "vm-progress-circle",
    style: ({
      height: _vm.width + 'px',
      width: _vm.width + 'px'
    })
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 100 100"
    }
  }, [_c('path', {
    staticClass: "vm-progress-circle__track",
    attrs: {
      "d": _vm.trackPath,
      "stroke": _vm.trackColor,
      "stroke-width": _vm.relativeStrokeWidth,
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "vm-progress-circle__path",
    style: (_vm.circlePathStyle),
    attrs: {
      "d": _vm.trackPath,
      "stroke-linecap": _vm.strokeLinecap,
      "stroke": _vm.stroke,
      "stroke-width": _vm.relativeStrokeWidth,
      "fill": "none"
    }
  })])]), _vm._v(" "), (_vm.showText && !_vm.textInside) ? _c('div', {
    ref: "progressText",
    staticClass: "vm-progress__text",
    style: ({
      fontSize: _vm.progressTextSize + 'px'
    })
  }, [(!_vm.st || _vm.strokeColor || _vm.$slots.default) ? [_vm._t("default", [_vm._v(_vm._s(_vm.percentage) + "%")])] : _c('i', {
    class: _vm.iconClass
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5afe9587", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5afe9587","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress.vue
// module id = 15
// module chunks = 0